import React, { useState } from "react";
import { Box, Typography, TextField, Button, useMediaQuery } from "@mui/material";
import { theme } from "../../common/style/Theme";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { default as contact } from "../../assets/technology.png";
import { default as logo } from "../../assets/logo.png";

const initialForm = {
  name: "",
  email: "",
  phone: "",
  company: "",
  message: ""
};

const initialError = {
  name: false,
  email: false,
  phone: false,
  message: false
};

const Contact = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState(initialError);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError({ ...error, [e.target.name]: false });
  };

  const validate = () => {
    let valid = true;
    let newError = { ...initialError };
    if (!form.name.trim()) { newError.name = true; valid = false; }
    if (!form.email.match(/^\S+@\S+\.\S+$/)) { newError.email = true; valid = false; }
    if (!form.phone.match(/^[0-9\-+\s()]{7,}$/)) { newError.phone = true; valid = false; }
    if (!form.message.trim()) { newError.message = true; valid = false; }
    setError(newError);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setSubmitted(true);
      setForm(initialForm);
      setTimeout(() => setSubmitted(false), 4000);
    }
  };

  return (
    <Box style={{
        height: "100%",
        width: "100%",
        background: `url(${contact})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
    }}>
        <Box style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "inherit",
            background: "rgba(0, 0, 0, 0.65)",
            zIndex: 0,
        }} />
        <Box style={{
            width: "75%",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            minHeight: isMobile ? 0 : 540,
            margin: "17vh 0",
            zIndex: 1,
        }}>
            <Box style={{
                flex: 1.2,
                background: theme.palette.common.white,
                padding: isMobile ? "7vw 5vw 5vw 5vw" : isTablet ? "4vw 3vw" : "4vw 4vw 4vw 5vw",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                borderTopLeftRadius: "10px",
                borderBottomLeftRadius: "10px",
            }}>
                <Typography variant="h4" style={{ fontWeight: 700, color: theme.palette.primary.main, marginBottom: 8 }}>
                    Contact Us
                </Typography>
                <Typography variant="body1" style={{ color: theme.palette.primary.main, marginBottom: 32 }}>
                    Have a question or want to work with us? Fill out the form and our team will get in touch with you soon.
                </Typography>
                <form onSubmit={handleSubmit} autoComplete="off">
                    <TextField
                        label="Name"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        error={error.name}
                        helperText={error.name ? "Name is required" : ""}
                        fullWidth
                        margin="normal"
                        size="medium"
                        required
                    />
                    <TextField
                        label="Email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        error={error.email}
                        helperText={error.email ? "Enter a valid email" : ""}
                        fullWidth
                        margin="normal"
                        size="medium"
                        required
                        type="email"
                    />
                    <TextField
                        label="Phone"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        error={error.phone}
                        helperText={error.phone ? "Enter a valid phone number" : ""}
                        fullWidth
                        margin="normal"
                        size="medium"
                        required
                        type="tel"
                    />
                    <TextField
                        label="Company"
                        name="company"
                        value={form.company}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        size="medium"
                    />
                    <TextField
                        label="Message"
                        name="message"
                        value={form.message}
                        onChange={handleChange}
                        error={error.message}
                        helperText={error.message ? "Message is required" : ""}
                        fullWidth
                        margin="normal"
                        size="medium"
                        multiline
                        minRows={4}
                        required
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="large"
                        style={{ 
                            marginTop: 24, 
                            borderRadius: 8, 
                            fontWeight: 600, 
                            fontSize: "1.1rem", 
                            padding: "12px 0" 
                        }}
                    >
                        Send Message
                    </Button>
                    {submitted && (
                        <Typography style={{ color: theme.palette.secondary.main, marginTop: 16, textAlign: "center" }}>
                            Thank you! Your message has been sent.
                        </Typography>
                    )}
                </form>
            </Box>
            <Box style={{
                flex: 1,
                background: isMobile ? theme.palette.background.default : theme.palette.primary.main,
                color: isMobile ? theme.palette.text.primary : theme.palette.common.white,
                padding: isMobile ? "7vw 5vw 5vw 5vw" : isTablet ? "4vw 3vw" : "4vw 4vw 4vw 3vw",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: isMobile ? "flex-start" : "flex-start",
                borderTopRightRadius: "10px",
                borderBottomRightRadius: "10px",
            }}>
                {/* Logo */}
                <Box style={{ 
                    display: "flex", 
                    justifyContent: "center", 
                    marginBottom: 24,
                }}>
                    <Box style={{
                        background: "rgba(255, 255, 255, 0.95)",
                        padding: "12px 20px",
                        borderRadius: "12px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <img 
                            src={logo} 
                            alt="M5 Info Solutions Logo" 
                            style={{ 
                                height: isMobile ? "50px" : "65px",
                                width: "auto",
                                objectFit: "contain"
                            }} 
                        />
                    </Box>
                </Box>
                
                <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 18 }}>
                    Get in Touch
                </Typography>
                <Box style={{ display: "flex", alignItems: "flex-start", marginBottom: 18 }}>
                    <LocationOnIcon style={{ marginRight: 12, fontSize: 28 }} />
                    <Box>
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                        M5 Info Solutions Pvt. Ltd.
                    </Typography>
                    <Typography variant="body2">
                        #54/3, 2nd Cross 1st R Block Rajajinagar,<br />
                        Bangalore - 560010,<br />
                        India
                    </Typography>
                    </Box>
                </Box>
                <Box style={{ display: "flex", alignItems: "center", marginBottom: 14, cursor: "pointer" }}>
                    <PhoneIcon style={{ marginRight: 12, fontSize: 24 }} />
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                        080-23577966
                    </Typography>
                </Box>
                <Box style={{ display: "flex", alignItems: "center", marginBottom: 14, cursor: "pointer" }}>
                    <EmailIcon style={{ marginRight: 12, fontSize: 24 }} />
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                        info@m5infosolutions.com
                    </Typography>
                </Box>
                
                {/* Google Maps */}
                <Box style={{ marginTop: 20, marginBottom: 20 }}>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.851015709394!2d77.55454731482194!3d12.99171709087213!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d6411bbb945%3A0x884e5e751a18bc1!2sRajajinagar%2C%20Bengaluru%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1640000000000!5m2!1sen!2sin"
                        width="100%"
                        height={isMobile ? "200" : "180"}
                        style={{ 
                            border: 0, 
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
                        }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="M5 Info Solutions Location"
                    />
                </Box>
                
                <Box style={{ marginTop: 32 }}>
                    <Typography variant="body2" style={{ opacity: 0.8 }}>
                    We typically respond within 1 business day.
                    </Typography>
                </Box>
            </Box>
        </Box>
    </Box>
  );
};

export default Contact;